<template>
  <v-container
          fill-height
          fluid
          grid-list-xl
  >
    <v-layout v-if="renderComponent" wrap>
      <v-flex
              md12
              lg12
      >
        <material-card
                class="card-tabs"
                color="green">
          <v-flex
                  slot="header"
          >
            <v-tabs
                    v-model="mytab"
                    color="transparent"
                    slider-color="white"
            >
              <span
                      class="subheading font-weight-light mr-3"
                      style="align-self: center"
              >Languages:</span>
              <v-tab v-for="(language,index1) of languages"
                      @click="changeLanguage('tab'+index1+1)"
                     :key="index1+1"
                     :href="`#tab-${index1+1}`"
                      class="mr-3">
                {{language.name}}
              </v-tab>
            </v-tabs>
          </v-flex>

          <v-tabs-items v-model="mytab">
            <v-tab-item
                    v-for="(language,index) of languages"
                    :key="index+1"
                    :value="`tab-${index+1}`"
            >
              <v-list three-line>
                <v-list-tile>
                  <v-flex
                          md12
                  >
                  <v-data-table
                          calculate-width
                          :headers="headers"
                          :items="items"
                          hide-actions
                  >
                    <template
                            slot="headerCell"
                            slot-scope="{ header }"
                    >
              <span
                      class="subheading font-weight-light text-success text--darken-3"
                      v-text="header.text"
              />
                    </template>
                    <template
                            slot="items"
                            slot-scope="{ item }"
                    >
                      <td style="width: 150px;overflow: hidden;"><img style="width: 80px;min-height: 80px;max-height: 80px;" :src="item.thumbnail"></td>
                      <td>{{item.batch_number}}</td>
                      <td v-if="item.post_transalation[index]"  style="width: 250px;overflow: hidden;" class="title-class">{{ item.post_transalation[index].top_middle_title }}</td>
                      <td v-else></td>
                      <td>{{item.author}}</td>
                      <td style="width: 200px;overflow: hidden;" class="text-xs-center">
                        <v-tooltip
                                top
                                content-class="top">
                          <v-btn
                                  @click="editPost(item.id)"
                                  slot="activator"
                                  class="v-btn--simple"
                                  color="success"
                                  icon
                          >
                            <v-icon color="primary">mdi-pencil</v-icon>
                          </v-btn>
                          <span>Edit</span>
                        </v-tooltip>
                        <v-tooltip
                                top

                                content-class="top">
                          <v-btn  @click="cloneNow(item)"
                                  slot="activator"
                                  class="v-btn--simple"
                                  color="success"
                                  icon>
                            <v-icon>mdi-content-copy</v-icon>
                          </v-btn>
                          <span>Duplicate</span>
                        </v-tooltip>
                        <v-tooltip
                                top

                                content-class="top">
                          <v-btn  @click="deleteNow(item)"
                                  slot="activator"
                                  class="v-btn--simple"
                                  color="danger"
                                  icon
                          >
                            <v-icon color="error">mdi-close</v-icon>
                          </v-btn>
                          <span>Delete</span>
                        </v-tooltip>
                      </td>
                    </template>
                  </v-data-table>
                  <pagination class="right" :data="pagination_data" @pagination-change-page="getlist">
                     <!-- <span slot="prev-nav">&lt; Previous</span>
    <span slot="next-nav">Next &gt;</span> -->
                  </pagination>

                    </v-flex>
                </v-list-tile>
              </v-list>
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="deleteDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Delete Post</v-card-title>
        <v-card-text>Are you sure! You want to delete "<b>{{ deletePost.batch_number}}</b>"?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="green darken-1" flat @click="deletePostSubmit() ">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cloneDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Duplicate product</v-card-title>
        <v-card-text>Are you sure! You want to duplicate "<b>{{ clonePost.batch_number }}</b>" ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="cloneDialog = false">Cancel</v-btn>
          <v-btn color="green darken-1" flat @click="getBatchNumber = true,cloneDialog=false">Duplicate</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="getBatchNumber" persistent max-width="500">
      <v-form ref="form"  v-model="valid">
        <v-card >
          <v-card-title class="headline">Duplicate product</v-card-title>
          <v-card-text>Enter a new <b>SKU</b>:
          </v-card-text>
          <v-container>
            <v-text-field
                    label="New SKU"
                    v-model="newBatchNumber"
                    type="text"
                    :rules="newBatchNumberRules"
                    required
            ></v-text-field>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click="getBatchNumber = false">Cancel</v-btn>
            <v-btn color="green darken-1" flat @click="submit(),getBatchNumber=false" :disabled="!valid" >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog
            v-model="progressDialog"
            hide-overlay
            persistent
            width="300"
    >
      <v-card
              color="primary"
              dark
      >
        <v-card-text>
          Loading Data
          <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import {list, postDelete, getLanguagesApi, duplicate} from "../api/routes";
  export default {
    data () {
      return {
        renderComponent:false,
        progressDialog: false,
        deletePost:{},
        valid: true,
        clonePost:{},
        mytab: 'tab-1',
        newBatchNumber: "",
        pagination_data: {},
        getBatchNumber: false,
        pages: 1,
        formHasErrors: false,
        deleteDialog:false,
        cloneDialog:false,
        languages:[],
        newBatchNumberRules: [
          v => !!v || "New SKU is required"
        ],
        headers: [
          {
            sortable: false,
            text: 'Image',
            value: 'image'
          },
          {
            sortable: false,
            text: 'Association Code',
            value: 'Batch No'
          },
          {
            sortable: false,
            text: 'Top Middle title',
            value: 'Top Middle title'
          },
          {
            sortable: false,
            text: 'Publisher',
            value: 'Publisher'
          },
          {
            sortable: false,
            text: 'Action',
            align: 'center'
          }
        ],
        items:[],
        tabs: 0,
      }
    },
    mounted() {
      var item = localStorage.getItem('CURRENT_LANGUAGE');

      this.getlist(1);
    },
    beforeMount(){
      this.progressDialog = true;
    },
    watch: {
      page: (newPage) => {
        console.log(newPage);
      }
    },
    methods: {
      submit: function () {
        const postData = {
          batch_id: this.newBatchNumber,
          old_batch_id: this.clonePost.id
        };

        duplicate(postData).then(response => {
            if (response.data.status === 200){
              this.$toasted.show('Product has been duplicated!',{
                type : 'success'});

            }
        }).catch(error => {
          this.$toasted.show('Error in duplicating product!',{
            type : 'error'});
          console.log(error)
        }).finally(final => {
          this.getlist(1);
        })

      },
      next(page){
          console.log(page);
          this.getlist(page);
      },
      getlist(page){
        this.tabs = this.tabs+1;
        list(page)
                .then(response => {
                  console.log(response)
                  this.items =response.data.data;
                  this.pagination_data = response.data;
                  this.getLanguages()
                })

                .catch(error => {
                  console.log(error);
                })
                .finally(() => {
                    this.progressDialog = false
                })
      },
      changeLanguage (tab) {
        this.mytab = tab;

       // this.getlist();
      },
      editPost(id){
        this.$router.push({
          name: 'Edit Post',
          params: { id: id }
        });
      },
      deleteNow(item) {
        console.log(item);
        this.deleteDialog = true;
        this.deletePost=item;

      },
      cloneNow(item) {
        console.log(item);
        this.cloneDialog = true;
        this.clonePost=item;

      },
      deletePostSubmit() {
     postDelete(this.deletePost)
                .then(response => {
                  this.loader = false;
                  this.getlist(1);
                  this.$toasted.show('Product has been deleted!',{
                    type : 'success'})
                })
                .catch(error => {
                  console.log(error);
                })
                .finally(() => {
                  this.deleteDialog = false;
                  this.deletePost = {};
                })

      },
      getLanguages(){
        getLanguagesApi().then(resp => {
          this.languages = resp.data.data;
          this.renderComponent = true;
          console.log(this.languages);
        }).catch(error => {
          console.log(error)
        });
      },
    }
  }
</script>
<style lang="css">
.pagination {
  display: block;
  max-width: 100%;
  width: 100%;
  float: left !important;
}
.pagination .page-item {
  width: 36px;
  float: left;
}
.page-item.active .page-link {

    background-color: #4caf50;
    border-color: #4caf50;
}
.page-link {

  color: #4caf50;

}
.page-link:hover {

  color: #4caf50;

}
  .subheading{
    font-weight: bold!important;
  }

 .theme--light.v-table thead tr:first-child {
  border-bottom: 2px solid rgb(216, 215, 215)!important;
}
</style>
